<template>
    <div class="signUP-admin">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    
                    <div class="signUp-admin-right signIn-admin-right p-md-40 p-10">
                        <div class="row justify-content-center">
                            <div class="col-xl-7 col-lg-8 col-md-12">
                                <h2>
                                    <center>
                                        MIGRASI DARI STARSENDER V2
                                    </center>
                                </h2>
                                <div v-if="step == 1" class="edit-profile mt-md-25 mt-0">
                                    <div class="card border-0">
                                        <div class="card-header border-0 pb-md-15 pb-10 pt-md-20 pt-10">
                                            <div class="edit-profile__title">
                                                <h6>1. Silahkan Login Menggunakan Akun STARSENDER V2</h6>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="edit-profile__body">
                                                <form method="POST" v-on:submit.prevent="signIn">
                                                    <div class="form-group mb-20">
                                                        <label for="username">
                                                            {{ $t("auth.username_or_email") }}
                                                        </label>
                                                        <input type="text" class="form-control" id="email"
                                                            placeholder="Email@example.com" v-model="form.email"
                                                            required />
                                                        <span class="invalid-feedback" role="alert">
                                                            <strong></strong>
                                                        </span>
                                                    </div>
                                                    <div class="form-group mb-15">
                                                        <label for="password-field">
                                                            {{ $t("auth.password") }}
                                                        </label>
                                                        <div class="position-relative">
                                                            <input id="password-field" :type="passwordFieldType"
                                                                class="form-control" placeholder="Password"
                                                                v-model="form.password" required />
                                                            <a v-on:click="togglePassword"
                                                                class="fa fa-fw fa-eye-slash text-light fs-16 field-icon toggle-password2"></a>
                                                            <span class="invalid-feedback" role="alert">
                                                                <strong></strong>
                                                            </span>
                                                        </div>
                                                    </div> 
                                                    <div
                                                        class="button-group d-flex pt-1 justify-content-md-start justify-content-center">
                                                        <button v-if="isLoading"
                                                            class="btn btn-primary btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn"
                                                            disabled>
                                                            <div class="spinner-border spinner" role="status"></div>
                                                            {{ $t("auth.loading") }}
                                                        </button>
                                                        <button v-else
                                                            class="btn btn-primary btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn">
                                                            {{ $t("auth.sign_in") }}
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else-if="step == 2" class="edit-profile mt-md-25 mt-0">
                                    <div class="card border-0">
                                        <div class="card-header border-0 pb-md-15 pb-10 pt-md-20 pt-10">
                                            <div class="edit-profile__title">
                                                <h6>2. Data Siap Dimigrasi</h6>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            <div class="edit-profile__body">
                                                <b>CATATAN : </b>
                                                <p>
                                                - Data anda di STARSENDER V2 tetap aman dan masih dapat diakses (dalam jangka waktu tertentu) walupun sudah dimigrasi
                                                <br>
                                                - Migrasi mungkin membutuhkan waktu, anda sudah dapat menggunakan v3 walupun migrasi sedang dilakukan
                                                <br>
                                                - Semua device membutuhkan scan ulang, karena server device harus dipindah ke server STARSENDER V3
                                                <br>
                                                - Jika ada pesan error silahkan kontak admin
                                                </p>
                                                <br>
                                                <div v-if="!migrationStart">
                                                    <button v-on:click="startMigration" class="btn btn-primary btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn">Mulai Migrasi</button>
                                                    <button v-on:click="back" class="btn btn-danger btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn">Kembali</button>

                                                </div>
                                                <div v-else>
                                                    <textarea style="height:160px" class="form-control mb-15" cols="30" rows="10" v-model="progres" readonly placeholder="Menunggu status migrasi..."></textarea>
                                                    <p v-if="migrationError" class="text-danger mb-10">{{ migrationError }}</p>
                                                    <button v-if="migrationFailed" v-on:click="retryMigration" class="btn btn-primary btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn">Coba migrasi lagi</button>
                                                    <button v-if="migrationDone" v-on:click="$router.push('/login')" class="btn btn-success btn-block btn-default btn-squared text-capitalize lh-normal px-50 py-15 signIn-createBtn">Login ke StarSender v3</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        components: {},
        data() {
            return {
                step: 1,
                form: {
                    email: "",
                    password: "",
                },
                token: "",
                migrationStart: false,
                progres: "",
                passwordFieldType: "password",
                isLoading: false,
                loggedInEmail: "",
                intv: null,
                pollTicks: 0,
                migrationError: "",
                migrationFailed: false,
                migrationDone: false,
                statusRequestTimeoutMs: 25000,
            };
        },
        beforeDestroy() {
            this.stopPolling()
        },
        mounted() {},
        methods: {
            stopPolling() {
                if (this.intv) {
                    clearInterval(this.intv)
                    this.intv = null
                }
            },
            parseStatusPayload(data) {
                if (data == null) {
                    return { idle: true, message: "Belum ada progres migrasi" }
                }
                if (typeof data === "string") {
                    if (data.startsWith("FAIL")) {
                        return { failed: true, progress: data, message: data.replace(/^FAIL\\s*-\\s*/, "") }
                    }
                    if (data === "SUCCESS") {
                        return { done: true, progress: data }
                    }
                    return { running: true, progress: data }
                }
                if (typeof data === "object") {
                    if (data.status === false) {
                        return { idle: true, message: data.message || "Belum ada progres migrasi" }
                    }
                    const progress = data.progress || data.message || ""
                    if (String(progress).startsWith("FAIL")) {
                        return { failed: true, progress: progress, message: String(progress).replace(/^FAIL\\s*-\\s*/, "") }
                    }
                    if (progress === "SUCCESS") {
                        return { done: true, progress: progress }
                    }
                    if (progress) {
                        return { running: true, progress: progress }
                    }
                }
                return { idle: true, message: "Status migrasi tidak dikenali" }
            },
            appendProgress(line) {
                if (!line) return
                if (this.progres.indexOf(line) === 0) return
                this.progres = line + "\n" + this.progres
            },
            startPolling(email) {
                this.stopPolling()
                this.pollTicks = 0
                this.track(email)
                this.intv = setInterval(() => {
                    this.pollTicks++
                    if (this.pollTicks > 360) {
                        this.stopPolling()
                        this.migrationError = "Pelacakan migrasi berhenti otomatis setelah ~1 jam. Silakan refresh halaman atau hubungi admin jika masih stuck."
                        return
                    }
                    this.track(email)
                }, 10000)
            },
            async signIn() {
                this.isLoading = true;

                try {
                    let login = await axios.post('https://starsender.online/api/migration/login',{
                        email: this.form.email,
                        password: this.form.password
                    })

                    if(login.data.status == 0){
                        this.$toast.error("Login Gagal")
                        this.isLoading = false
                        return
                    }

                    //CHECK MIGRATION STATUS
                    this.loggedInEmail = login.data.email
                    this.token = login.data.token
                    let track = await axios.get(
                        'https://migrator.starsender.online/status?email=' + encodeURIComponent(login.data.email),
                        { timeout: this.statusRequestTimeoutMs }
                    )
                    const st = this.parseStatusPayload(track.data)

                    this.$toast.success("Login Sukses")
                    this.step = 2
                    this.migrationError = ""
                    this.migrationFailed = false
                    this.migrationDone = false

                    if (st.idle) {
                        this.migrationStart = false
                        this.progres = ""
                    } else {
                        this.migrationStart = true
                        this.progres = st.progress || ""
                        if (st.failed) {
                            this.migrationFailed = true
                            this.migrationError = st.message || "Migrasi gagal"
                        } else if (st.done) {
                            this.migrationDone = true
                        } else {
                            this.startPolling(this.loggedInEmail)
                        }
                    }


                    // await this.$store.dispatch("auth_login", this.form);
                    // await this.$root.$emit("login", true);
                    // //this.$toast.success("Login success");
                    // await this.$router.push("/dashboard");
                    //window.location.reload()
                } catch (err) {
                    const msg = err?.response?.data?.message || err?.message || "Login migrasi gagal"
                    this.$toast.error(msg)
                }
                this.isLoading = false;
            },
            async startMigration(){
                if(!this.token) return this.$toast.error("Silakan refresh halaman")
                this.migrationStart = true
                this.migrationError = ""
                this.migrationFailed = false
                this.migrationDone = false
                this.progres = "Memulai migrasi..."

                try {
                    await axios.post('https://migrator.starsender.online/migrate', {
                        token: this.token,
                    }, { timeout: this.statusRequestTimeoutMs })
                    this.startPolling(this.loggedInEmail)
                } catch (err) {
                    const msg = err?.response?.data?.message || err?.message || "Gagal memulai migrasi"
                    this.migrationFailed = true
                    this.migrationError = msg
                    this.progres = "FAIL - " + msg
                    this.$toast.error(msg)
                }
            },
            retryMigration() {
                this.migrationFailed = false
                this.migrationError = ""
                this.progres = ""
                this.startMigration()
            },
            async track(id){
                try {
                    let track = await axios.get(
                        'https://migrator.starsender.online/status?email=' + encodeURIComponent(id),
                        { timeout: this.statusRequestTimeoutMs }
                    )
                    const st = this.parseStatusPayload(track.data)

                    if (st.idle) {
                        if (!this.progres) {
                            this.migrationError = st.message || "Belum ada progres migrasi. Jika baru klik Mulai Migrasi, tunggu beberapa detik lalu coba lagi."
                        }
                        return
                    }

                    this.appendProgress(st.progress)
                    this.migrationError = ""

                    if (st.failed) {
                        this.stopPolling()
                        this.migrationFailed = true
                        this.migrationError = st.message || "Migrasi gagal"
                        this.$toast.error(this.migrationError)
                        return
                    }

                    if (st.done) {
                        this.stopPolling()
                        this.migrationDone = true
                        this.$toast.success("Migrasi sukses, silakan login ke v3")
                        return
                    }

                    if (st.running && st.progress && st.progress !== "STARTING" && !this.migrationDone) {
                        this.$toast.info("Migrasi berjalan di background. Anda sudah bisa login ke v3 sambil menunggu selesai.")
                    }
                } catch (err) {
                    const msg = err?.response?.data?.message || err?.message || "Gagal cek status migrasi"
                    this.migrationError = msg + " (akan dicoba lagi otomatis)"
                }
            },
            togglePassword() {
                if (this.passwordFieldType == "password") {
                    this.passwordFieldType = "text"
                } else {
                    this.passwordFieldType = "password"
                }
            },
            back(){
                this.stopPolling()
                this.step = 1;
                this.form.email = ""
                this.form.password = ""
                this.token = ""
                this.migrationStart = false
                this.progres = ""
                this.migrationError = ""
                this.migrationFailed = false
                this.migrationDone = false
            }
        },
    };
</script>

<style scoped>
    .spinner {
        height: 1rem !important;
        width: 1rem !important;
    }

    .btn {
        line-height: 1rem !important;
    }
    .signUP-admin {
        background-color: #f4f5f7;
    }
</style>